import { useOrderStatusLabel } from 'hooks/business/chat/useOrder';
import dayjs from 'lib/dayjs';
import { CopyText } from '../CopyText';
import { useTranslate } from '@tolgee/react';
import { Button, Popover, Tag } from 'antd';
import { useState } from 'react';

interface OrderStatusProps {
  tradeStatus: Conversation.Trade.Status;
  createTime: number | string;
  externalTradeId: Conversation.Trade.Vo['externalTradeId'];
  replacedOrderId?: string;
  exchangeSourceOrderId: string;
  generatedOrders?: {
    orderId: string;
    orderTag: 'REPLACEMENT_ORDER' | 'EXCHANGE_ORDER';
  }[];
  onScrollToOrder?: (externalTradeId: string) => void;
  tradeName?: string;
}

export const OrderStatus = (props: OrderStatusProps) => {
  const {
    tradeStatus,
    createTime,
    externalTradeId,
    replacedOrderId,
    exchangeSourceOrderId,
    generatedOrders,
    onScrollToOrder,
    tradeName,
  } = props;
  const orderStatusLabel = useOrderStatusLabel(tradeStatus);
  const { t } = useTranslate();

  const [visible, setVisible] = useState(false);

  return (
    <div className="pt-4">
      <div className="flex items-center justify-between">
        <span className="text-[14px] text-[var(--fett-text-primary)] font-medium">
          {orderStatusLabel}
        </span>
        {exchangeSourceOrderId ||
        replacedOrderId ||
        generatedOrders?.some(
          ({ orderTag }) => orderTag === 'EXCHANGE_ORDER' || orderTag === 'REPLACEMENT_ORDER',
        ) ? (
          <Popover
            visible={visible}
            onVisibleChange={setVisible}
            placement="topRight"
            content={
              <div>
                {exchangeSourceOrderId && (
                  <div className="flex items-center">
                    <span className="text-[var(--fett-text-tertiary)]">
                      {t('来源订单')}: {exchangeSourceOrderId}
                    </span>
                    {onScrollToOrder && (
                      <Button
                        type="link"
                        onClick={() => {
                          onScrollToOrder(exchangeSourceOrderId);
                          setVisible(false);
                        }}
                      >
                        {t('aide.查看')} →
                      </Button>
                    )}
                  </div>
                )}
                {replacedOrderId && (
                  <div className="flex items-center">
                    <span className="text-[var(--fett-text-tertiary)]">
                      {t('来源订单')}: {replacedOrderId}
                    </span>
                    {onScrollToOrder && (
                      <Button
                        type="link"
                        onClick={() => {
                          onScrollToOrder(replacedOrderId);
                          setVisible(false);
                        }}
                      >
                        {t('aide.查看')} →
                      </Button>
                    )}
                  </div>
                )}
                {generatedOrders?.map(({ orderTag, orderId }) => {
                  if (orderTag === 'EXCHANGE_ORDER') {
                    return (
                      <div key={orderId} className="flex items-center">
                        <span className="text-[var(--fett-text-tertiary)]">
                          {t('已生成换货订单')}: {orderId}
                        </span>
                        {onScrollToOrder && (
                          <Button
                            type="link"
                            onClick={() => {
                              onScrollToOrder(orderId);
                              setVisible(false);
                            }}
                          >
                            {t('aide.查看')} →
                          </Button>
                        )}
                      </div>
                    );
                  }
                  if (orderTag === 'REPLACEMENT_ORDER') {
                    return (
                      <div key={orderId} className="flex items-center">
                        <span className="text-[var(--fett-text-tertiary)]">
                          {t('已生成补发订单')}: {orderId}
                        </span>
                        {onScrollToOrder && (
                          <Button
                            type="link"
                            onClick={() => {
                              onScrollToOrder(orderId);
                              setVisible(false);
                            }}
                          >
                            {t('aide.查看')} →
                          </Button>
                        )}
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
            }
          >
            <Tag
              color="blue"
              style={{ border: 'none', fontSize: 12, margin: 0, cursor: 'pointer' }}
            >
              {t(
                exchangeSourceOrderId ? '换货订单' : replacedOrderId ? '补发订单' : 'todo.关联订单',
              )}
            </Tag>
          </Popover>
        ) : null}
      </div>
      <div className="mt-1 flex items-center justify-between text-[12px] text-[var(--fett-text-tertiary)]">
        <CopyText text={externalTradeId} tooltip={t('订单编号')} showIcon />
        <span>{dayjs(Number(createTime)).format('YYYY-MM-DD, HH:mm')}</span>
      </div>
      {tradeName ? (
        <div className="text-[12px] text-[var(--fett-text-tertiary)]">{tradeName}</div>
      ) : null}
    </div>
  );
};
